import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel, TableRow } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
// import { simpleFitCell } from './FitnessTrackerListe';
import { AgtSocialMediaVM } from 'app/stores/ui/agt.socialmedia.ui.store';
import { Icon } from 'app/components/common/Icon';
import { formatNum, formatNumIgnoreNullAndUndefined } from 'app/utils';

interface ISichtkontakteListe {
	gpMode?: boolean;
}

export const SichtkontakteListe = observer((props: ISichtkontakteListe) => {
	const { berichteUiiStore, agtSocialMediaUiStore, agenturListUiStore, session } = useStore();
	const [hasItems, setHasItems] = useState(false);
	const tm = new TableModel<AgtSocialMediaVM, number>();
	const cols: ITableColumn<AgtSocialMediaVM, number>[] = [];

	cols.push({
		label: 'Agentur',
		path: 'agt.name',
		sortBy: 'agt.name',
		render: AgenturNameCell,
	});

	if (props.gpMode) {
		cols.push({
			label: 'GP',
			path: 'hasMoreThan30kViewsMultiGp26',
			render(row) {
				return <>{row.data.hasMoreThan30kViewsMultiGp26 > 0 ? <Icon iconClass="check-circle" faModifier="far" /> : <></>}</>;
			},
			agg: [
				{
					aggType: AggregrationType.sum,
					path: `hasMoreThan30kViewsMultiGp26GpCount`,
				},
			],
		});
		cols.push({
			label: 'Teilhaber',
			path: `agt.thCount`,
			agg: [
				{
					aggType: AggregrationType.sum,
				},
			],
		});
	}

	cols.push({
		label: 'FB',
		path: `ytdFbViews`,
		sortBy: `ytdFbViews`,
		sortType: 'number',
		format: formatNum,
		agg: [
			{
				path: `ytdFbViews`,
				aggType: AggregrationType.sum,
			},
		],
	});

	cols.push({
		label: 'Instagram',
		path: `ytdInstaViews`,
		sortBy: `ytdInstaViews`,
		sortType: 'number',
		format: formatNum,
		agg: [
			{
				path: `ytdInstaViews`,
				aggType: AggregrationType.sum,
			},
		],
	});
	if (!props.gpMode) {
		cols.push({
			label: 'TitTok',
			path: `ydtTiktokViews`,
			sortBy: `ydtTiktokViews`,
			sortType: 'number',
			format: formatNumIgnoreNullAndUndefined,
			agg: [
				{
					path: `ydtTiktokViews`,
					aggType: AggregrationType.sum,
				},
			],
		});
		cols.push({
			label: 'LinkedIn',
			path: `ytdLinkedinViews`,
			sortBy: `ytdLinkedinViews`,
			sortType: 'number',
			format: formatNumIgnoreNullAndUndefined,
			agg: [
				{
					path: `ytdLinkedinViews`,
					aggType: AggregrationType.sum,
				},
			],
		});
	}
	if (props.gpMode) {
		cols.push({
			label: 'Summe der Sichtkontakte GP',
			path: `allViewsYtdMultiGp`,
			sortBy: `allViewsYtdMultiGp`,
			sortType: 'number',
			format: formatNumIgnoreNullAndUndefined,
			agg: [
				{
					path: `allViewsYtdMultiGp`,
					aggType: AggregrationType.sum,
				},
			],
		});
	} else {
		cols.push({
			label: 'Summe der Sichtkontakte',
			path: `allViewsYtd`,
			sortBy: `allViewsYtd`,
			sortType: 'number',
			format: formatNumIgnoreNullAndUndefined,
			agg: [
				{
					path: `allViewsYtd`,
					aggType: AggregrationType.sum,
				},
			],
		});
	}

	tm.sortBy = 'agt.name';
	tm.setCols(cols);

	tm.idProperty = 'agtId';
	tm.idType = 'number';

	useEffect(() => {
		agtSocialMediaUiStore.loadYtd().then((vms) => {
			let items = vms;
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = items.filter((i) => i.agt.agtId === agtId);
			} else {
				items = agenturListUiStore.applyFilterOnAgt(items) as AgtSocialMediaVM[];
				items = agenturListUiStore.applyFilterOnGpRelevantAgt(items) as AgtSocialMediaVM[];
			}
			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [tm, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore, agtSocialMediaUiStore]);

	return (
		<>
			{!hasItems ? (
				<div className="pad-1rem">Keine Daten gefunden</div>
			) : (
				<>
					<Table stickyHeader={true} tm={tm} stickyFooter={true}></Table>
				</>
			)}
		</>
	);
});
